<div class="error-container">
    <h1>{{statusCode}}</h1>
    <p class="error-reason">{{errorHeader}}</p>
	<p class="options">
		{{errorDescriptionToDisplay}}<a [routerLink]="homePage">{{'Errors.Homepage' | translate}}</a>{{errorDescriptionToDisplay2}}
	</p>
</div>